import classNames from "classnames";
import _ from "lodash";
import { useFormContext } from "react-hook-form";
import { FormFieldProps } from "./LInputField";
import "./LCheckbox.module.css";
import { convertToSentenceCase } from "@helpers/stringHelper";

export const LRadio = ({ ...props }: RadioProps): JSX.Element => {
    const {
        register,
        formState: { errors }
    } = useFormContext();
    const error = _.get(errors, props.inputName);
    const hasError = error !== undefined && error !== null && !props.hideError;

    const classes = classNames("radio", "is-flex", "is-align-items-center", hasError ? "is-danger" : "", props.classes);

    return (
        <div className="field">
            <label className={`${classes} `}>
                <input
                    id={props.id}
                    type="radio"
                    checked={props.checked}
                    value={props.value}
                    {...register(props.inputName, { onChange: props.onChange })}
                    defaultChecked={props.defaultChecked}
                    onClick={props.onChecked}
                />
                {props.value && (
                    <span className="my-1 mx-4">
                        {props.shouldCap ? convertToSentenceCase(props.value) : props.value}
                    </span>
                )}
            </label>
        </div>
    );
};

interface RadioProps extends FormFieldProps {
    id: string;
    checked?: boolean;
    classes?: string;
    hideError?: boolean;
    defaultChecked?: boolean;
    shouldCap?: boolean;
    onChecked?: () => void;
}
